import { withNamespaces } from 'react-i18next';
import {
    Col,
    Row,
} from 'reactstrap';

import { BidRiskLevels, BidVerificationOutcomes } from '../constants';

const VerificationStatusBanner = ({
    outcome,
    t,
}) => {
    const preset = BidVerificationOutcomes[outcome.status] || {};
    const color = outcome.color || preset.color;
    const icon = outcome.icon || preset.icon;
    const title = outcome.title || preset.title;

    return (
        <div className={`bid-status-banner ${color} rounded p-3 mb-4`}>
            <Row className="align-items-center">
                <Col lg="8">
                    <div className="d-flex align-items-start">
                        <i className={`${icon} banner-icon me-2`} />
                        <div>
                            <h4 className="banner-title fw-bold mb-1">
                                {t(title)}
                            </h4>
                            <p className="fw-normal mb-0">{t(outcome.description)}</p>
                        </div>
                    </div>
                </Col>
                <Col lg="4">
                    <div className="d-flex flex-column gap-2" style={{
                        borderLeft: '1px solid #c6c6c6',
                        paddingLeft: '30px',
                    }}>
                        {outcome.metrics.map((metric) => {
                            const risk = metric.type === 'risk' ? BidRiskLevels[metric.value] : null;

                            return (
                                <div className="d-flex justify-content-between align-items-center" key={metric.label}>
                                    <span className="fw-normal">{t(metric.label)}</span>
                                    {risk ? (
                                        <span className={`badge p-2 ${risk.className}`}>
                                            {t(risk.title)}
                                        </span>
                                    ) : (
                                        <span className={`fw-bold ${metric.className ? 'recommendation' : ''}`}>
                                            {typeof metric.value === 'string' ? t(metric.value) : metric.value}
                                        </span>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default withNamespaces()(
    VerificationStatusBanner
);
